import { useEffect } from 'react';

import useMenuCategoryStorage from './hooks/useMenuCategoryStorage';

const InitialMenuCategories: React.FunctionComponent = () => {
  const { fillMenuCategoriesState } = useMenuCategoryStorage();

  useEffect(() => {
    fillMenuCategoriesState();
  }, []);

  return <></>;
};

export default InitialMenuCategories;
